<template>
  <div class="boilPlan column-me">
    <div class="card-div column-me flex1">
      <div class="row-me row-center">
        <div class="width300">
          <el-input placeholder="方案名称" style="width: 100%;" clearable v-model="name"></el-input>
        </div>
        <div class="width300 margin-left10">
          <el-select placeholder="适用剂型" style="width: 100%;" filterable clearable multiple
                     collapse-tags collapse-tags-tooltip v-model="selectType">
            <el-option v-for="item in typeArray" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          搜索
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">清空</div>
      </div>
      <div class="btn-blue width150 btn-height40 margin-top20" @click="clickAdd" v-if="canOperate">新增煎药方案</div>
      <div class="margin-top20">
        <el-table :data="tableData" border header-cell-class-name="table-header-style"
                  cell-class-name="table-cell-style">
          <el-table-column prop="name" label="方案名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="typeName" label="适用剂型" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="content" label="方案内容" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" align="center" show-overflow-tooltip width="180" v-if="canOperate">
            <template #default="scope">
              <div class="row-me center-all">
                <div class="blue-text" @click="clickEdit(scope.row)">编辑</div>
                <div class="blue-text margin-left30" @click="clickDelete(scope.row)">删除</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="margin-top10">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="pageNo"
                       layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 弹窗 -->
    <el-dialog :title="title" v-model="visible" width="50%" top="10vh" :destroy-on-close="true">
      <div>
        <div class="row-me row-center">
          <div class="left-div"><span class="red-star">*</span>方案名称：</div>
          <div class="width400">
            <el-input placeholder="请输入" style="width: 100%;" clearable v-model="detailItem.name"
                      maxlength="100"></el-input>
          </div>
        </div>
        <div class="row-me row-center margin-top20">
          <div class="left-div"><span class="red-star">*</span>适用剂型：</div>
          <div class="width400">
            <el-select placeholder="请选择" style="width: 100%;" filterable clearable multiple
                       collapse-tags collapse-tags-tooltip v-model="detailItem.typeName">
              <el-option v-for="item in typeArray" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row-me row-center margin-top20">
          <div class="left-div">泡药：</div>
          <el-switch v-model="detailItem.isOpenPaoYao" active-color="#61C565"></el-switch>
          <div class="row-me row-center" v-if="detailItem.isOpenPaoYao">
            <div class="width100 margin-left30">
              <el-input placeholder="请输入" style="width: 100%;" clearable v-model="detailItem.paoTime"
                        @input="detailItem.paoTime=$method.checkInput(detailItem.paoTime,1)"></el-input>
            </div>
            <div class="margin-left10">分钟</div>
            <div class="margin-left30" style="color: #555F69;">*泡药过程中如果未达到泡药时间则无法完成泡药</div>
          </div>
        </div>
        <div class="row-me row-center margin-top20">
          <div class="left-div">煎药：</div>
          <el-switch v-model="detailItem.isOpenJianYao" active-color="#61C565"></el-switch>
          <div class="row-me row-center" v-if="detailItem.isOpenJianYao">
            <div class="width100 margin-left30">
              <el-input placeholder="请输入" style="width: 100%;" clearable v-model="detailItem.jianTime"
                        @input="detailItem.jianTime=$method.checkInput(detailItem.jianTime,1)"></el-input>
            </div>
            <div class="margin-left10">分钟</div>
            <div class="margin-left30" style="color: #555F69;">*煎药过程中如果未达到煎药时间则无法完成煎药</div>
          </div>
        </div>
        <div class="row-me margin-top20">
          <div class="left-div"><span class="red-star">*</span>方案内容：</div>
          <div class="flex1">
            <el-input type="textarea" placeholder="请输入" style="width: 100%;" clearable
                      v-model="detailItem.content" maxlength="400" show-word-limit autosize></el-input>
          </div>
        </div>
        <div class="row-me margin-top20">
          <div class="left-div">备注：</div>
          <div class="flex1">
            <el-input type="textarea" placeholder="请输入" style="width: 100%;" clearable
                      v-model="detailItem.remark" maxlength="500" show-word-limit autosize></el-input>
          </div>
        </div>
        <div class="row-me row-center flex-end1 margin-top80">
          <div class="btn-blank width110 btn-height40" @click="visible=false">取消</div>
          <div class="btn-blue width110 btn-height40 margin-left20" @click="clickSave">保存</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      name: '',
      selectType: [],
      typeArray: [],
      visible: false,
      tableData: [],
      title: '',
      detailItem: {},
      pageNo: 1,
      total: 0,
      canOperate: false,
    }
  },
  // 侦听器
  watch: {},
  // 计算属性
  computed: {},
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.typeArray = ['汤剂(代煎)', '汤剂(自煎)', '膏剂', '散剂', '颗粒剂', '中医外治', '丸剂-水丸', '丸剂-大蜜丸',
      '丸剂-水蜜丸', '丸剂-浓缩丸']
    this.clickSearch()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    clickSearch() {
      this.pageNo = 1
      this.getData()
    },
    //清空
    clickClear() {
      this.name = ''
      this.selectType = []
      this.clickSearch()
    },
    clickAdd() {
      this.title = '新增煎药方案'
      this.detailItem = {
        isOpenPaoYao: true,
        isOpenJianYao: true,
      }
      this.visible = true
    },
    clickEdit(item) {
      this.title = '修改煎药方案'
      this.detailItem = this.$method.deepClone(item)
      this.detailItem.typeName = this.detailItem.typeName.split(',')
      this.visible = true
    },
    clickDelete(item) {
      this.$confirm("您确定要删除吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postFormRequest('/admin/systemConfig/decoctSchemeDelete', {
          id: item.id
        }).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    clickSave() {
      if (this.$method.isEmpty(this.detailItem.name)) {
        this.$message.error("请输入方案名称")
        return
      }
      if (this.$method.isEmpty(this.detailItem.typeName)) {
        this.$message.error("请选择适用剂型")
        return
      }
      if (this.detailItem.isOpenPaoYao) {
        if (this.$method.isEmpty(this.detailItem.paoTime)) {
          this.$message.error("请输入泡药时间")
          return
        }
        if (Number(this.detailItem.paoTime) === 0) {
          this.$message.error("泡药时间不能为0")
          return
        }
        if (isNaN(Number(this.detailItem.paoTime))) {
          this.$message.error("请输入正确的泡药时间")
          return
        }
      }
      if (this.detailItem.isOpenJianYao) {
        if (this.$method.isEmpty(this.detailItem.jianTime)) {
          this.$message.error("请输入煎药时间")
          return
        }
        if (Number(this.detailItem.jianTime) === 0) {
          this.$message.error("煎药时间不能为0")
          return
        }
        if (isNaN(Number(this.detailItem.jianTime))) {
          this.$message.error("请输入正确的煎药时间")
          return
        }
      }
      if (this.$method.isEmpty(this.detailItem.content)) {
        this.$message.error("请输入方案内容")
        return
      }
      let param = this.$method.deepClone(this.detailItem)
      param.typeName = param.typeName.toString()
      this.$postRequest('/admin/systemConfig/decoctSchemeUpdate', param).then((res) => {
        if (res) {
          this.visible = false
          this.$message.success(res.message)
          this.clickSearch()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getData()
    },
    //获取数据
    getData() {
      this.$postFormRequest('/admin/systemConfig/decoctSchemePage', {
        name: this.name,
        typeName: this.selectType,
        pageNumber: this.pageNo,
      }).then((res) => {
        if (res) {
          this.total = res.data.totalRow
          this.tableData = res.data.list
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.boilPlan {
  height: 100%;

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
  }

  .left-div {
    width: 120px;
    text-align: right;
    margin-right: 10px;
  }
}
</style>
